import React, { useState } from "react";

// utils
import {
  LISTING_TYPE,
  RENTAL_CONTRACT_SECONDS_PER_INTERVAL,
  SEC_IN_A_DAY,
} from "../platformUtils";

// media
import sampleMetaverseCityIsoBlueImg from "../media/placeholder-imgs/sample-metaverse-city-iso-blue.png";
import sampleMetaverseCityOrangeImg from "../media/placeholder-imgs/sample-metaverse-city-orange.png";
import sampleMetaverseCityPurpleImg from "../media/placeholder-imgs/sample-metaverse-city-purple.png";
import sampleMetaverseCityTopGoldImg from "../media/placeholder-imgs/sample-metaverse-city-top-gold.png";

// let sampleMetaverseCityIsoBlueImg = '';
// let sampleMetaverseCityOrangeImg  = '';
// let sampleMetaverseCityPurpleImg  = '';
// let sampleMetaverseCityTopGoldImg = '';


// sample data to copy paste
const SAMPLE_DATA = [
  {
    name: "Cozy cabin on outskirts of District X",
    address: "0x1234567890abcdef",
    tokenId: "1234567890",
    owner: "0xaaaaaaabcdef",
    metaverse: "Decentraland",
    listingType: LISTING_TYPE.FOR_SALE,
    price: 2.58,
    currency: "eth",
    imgUrls: [sampleMetaverseCityOrangeImg, sampleMetaverseCityPurpleImg],
    views: 121,
    likes: 32,
    posX: 0,
    posY: 0,
    rentalInfo: {
      rentalPrice: 0.01,
      rentalCurrency: "eth",
      rentalPeriodSec: RENTAL_CONTRACT_SECONDS_PER_INTERVAL,
      rentalStartSec: Math.floor(Date.now() / SEC_IN_A_DAY) - 7 * SEC_IN_A_DAY,
      rentalEndSec: Math.floor(Date.now() / SEC_IN_A_DAY) + 7 * SEC_IN_A_DAY,
      tenant: "0x1234567890abcdef",
      landlord: "0xbbbbbbbbbbbb",
    },
    isProperty: true,
  },
  {
    name: "Cozy cabin on outskirts of District X",
    address: "0x123456789230abcdef",
    tokenId: "1234567890",
    owner: "0xaaaaa234aabcdef",
    metaverse: "CryptoVoxels",
    listingType: LISTING_TYPE.FOR_SALE,
    price: 2.58,
    currency: "eth",
    imgUrls: [sampleMetaverseCityPurpleImg],
    views: 121,
    likes: 32,
    posX: 0,
    posY: 0,
    isProperty: true,
  },
  {
    name: "Cozy cabin on outskirts of District X",
    address: "0x1234567890abcdef",
    tokenId: "1234567890",
    owner: "0x1232222290abcdef",
    metaverse: "Decentraland",
    listingType: LISTING_TYPE.FOR_SALE,
    price: 2.58,
    currency: "eth",
    imgUrls: [sampleMetaverseCityIsoBlueImg],
    views: 121,
    likes: 32,
    posX: 0,
    posY: 0,
    isProperty: true,
  },
  {
    name: "Cozy cabin on outskirts of District X",
    address: "0x1234567890abcdef",
    tokenId: "1234567890",
    owner: "0x1ccccccccdef",
    metaverse: "The Sandbox",
    listingType: LISTING_TYPE.FOR_SALE,
    price: 2.58,
    currency: "eth",
    imgUrls: [sampleMetaverseCityTopGoldImg],
    views: 121,
    likes: 32,
    posX: 0,
    posY: 0,
    isProperty: true,
  },
];

function useSampleProperties(amt) {
  const samplePropertiesLooped = new Array(amt).fill(0).map((emptyVal, i) => {
    // clone the sample data
    let newProperty = JSON.parse(
      JSON.stringify(SAMPLE_DATA[i % SAMPLE_DATA.length])
    );

    // set newData.tokenId to be random number between 100 and 100000
    newProperty.tokenId = Math.floor(Math.random() * 100000) + 100;

    return newProperty;
  });

  // populate sample properties by looping the above data <amt> times
  const [sampleProperties, setSampleProperties] = useState(
    samplePropertiesLooped
  );

  return sampleProperties;
}
export default useSampleProperties;